<template>
<div>
<Attendance/>

</div>
</template>
<script>
import Attendance from "../../components/academic/Attendance.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
    Attendance
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>